<template>
  <div class="main-content">
    <md-tabs
      class="md-primary"
      md-centered
      md-elevation="1"
      @change="onAreaChangeDelegate"
    >
      <md-tab
        v-for="(area, tabindex) in certificationProcess.areas"
        :id="`tab-${tabindex}`"
        :key="tabindex"
        :md-label="area.name"
        style="overflow-wrap: break-word;"
        :md-active="(tabindex === activeIndex)"
      >
        <md-layout md-column>
          <span class="md-title">{{ area.name }}</span>
          <span class="caption" v-if="area.description && area.description.trim().length > 0"
          ><b>Informações adicionais:</b> {{area.description}}.</span
          >
          <span class="caption"
          >Adicione os equipamentos existentes na área.</span
          >
        </md-layout>

        <md-list>
          <md-list-item
            v-for="(structure, index) in area.structures"
            :key="index"
          >
            <div class="md-list-text-container">
              <span>{{ structure.name }}</span>
              <p>{{ structure.description }}</p>
            </div>

            <md-button
              v-if="area.status !== 2"
              class="md-icon-button md-list-action"
              @click="onEditStructure(index)"
            >
              <md-icon class="md-primary">edit</md-icon>
            </md-button>

            <md-divider class="md-inset"></md-divider>
          </md-list-item>
        </md-list>
        <p v-if="area.status === 2" class="md-warn md-center">
          <md-icon>warning</md-icon>
          <b>ATENÇÃO:</b>
          NÃO É POSSÍVEL ALTERAR OU EDITAR AS INFORMAÇÕES DESTA ÁREA APÓS A
          SINCRONIZAÇÃO DAS FOTOS.
        </p>
        <p v-else class="no-equipments">
          <md-button class="md-raised md-primary" @click="addStructure()"
          >ADICIONAR EQUIPAMENTO
          </md-button
          >
        </p>

        <md-layout md-row>
          <md-layout md-column>
            <md-button class="md-accent md-dense" @click="prevArea(tabindex)"
                       v-if="tabindex !== 0">
              <span><md-icon class="md-accent">arrow_left</md-icon>ÁREA ANTERIOR</span>
            </md-button>
          </md-layout>
          <md-layout md-column>
            <md-button class="md-accent md-dense" @click="nextArea(tabindex)"
                       v-if="certificationProcess.areas.length > 1 &&
                       tabindex !== certificationProcess.areas.length-1"><span>PRÓXIMA ÁREA <md-icon class="md-accent">arrow_right</md-icon></span>
            </md-button>
          </md-layout>
        </md-layout>
        <!-- <div class="blueprint">
          <svg preserveAspectRatio="xMinYMin meet " style="display:flex" :viewBox="`${area.x} ${area.y-2} ${parseInt(area.w,10)} ${parseInt(area.h,10)}`" :height="this.window.innerHeight-211" :width="this.window.innerWidth">
            <image x="0" y="0" :xlink:href="blueprint " :height="bpHeight" :width="bpWidth" />
            <rect :x="area.x+1.5" :y="area.y" width="95%" height="100%" style="fill:#ff6f00;stroke:#f4511e;stroke-width:1;opacity:0.5"  fill-opacity="0.2"></rect>
          </svg>
          <draggableStructure v-for="(structure, index) in area.structures" :value="structure" :number="index" :data-key="index" :key="index" class="draggable-structure"></draggableStructure>
        </div> -->
      </md-tab>
    </md-tabs>
    <!-- <md-button
      class="md-fab  md-primary md-fab-bottom-right"
      @click="addStructure()"
    >
      <md-icon>add</md-icon>
    </md-button> -->
    <addStructureDialog
      ref="add_structure_dialog"
      :activeProcess="certificationProcess"
    ></addStructureDialog>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import DraggableStructure from '@/components/DraggableStructure'
import AddStructureDialog from '@/components/AddStructureDialog'

export default {
  name: 'structure',
  components: {
    DraggableStructure,
    AddStructureDialog
  },
  data: () => ({
    currentAreaKey: 0,
    blueprint: '',
    bpHeight: 100,
    bpWidth: 100,
    wHeight: 100,
    wWidth: 100,
    activeIndex: 0
  }),
  computed: {
    ...mapState({
      certificationProcess: (state) => state.certificationProcess
    })
  },
  // beforeDestroy() {
  //   this.$interact('.draggable-structure').unset()
  // },
  created() {
    this.wHeight = window.innerHeight - 155
    this.wWidth = window.innerWidth
    this.FETCH_DATA().then(() => {
      // this.bpHeight = this.certificationProcess.bpHeight
      // this.bpWidth = this.certificationProcess.bpWidth
      // this.FETCH_IMAGE(this.certificationProcess.blueprint).then(imageBlob => {
      //   this.loadBlueprint(imageBlob)
      // })
    })
    // window.dragMoveListener = this.dragMoveListener
  },
  mounted() {
    // this.setInteractive()
  },
  methods: {
    ...mapActions(['FETCH_DATA', 'SET_PROCESS', 'FETCH_IMAGE', 'SET_AREA']),
    // loadBlueprint(imageBlob) {
    //   var vm = this
    //   let fileReader = new FileReader()
    //   fileReader.onload = function(e) {
    //     vm.blueprint = e.target.result
    //     var img = new Image()
    //     img.src = vm.blueprint
    //     img.onload = () => {
    //       // let ratio = Math.min((window.innerWidth - 16) / img.width,(window.innerHeight - 48) / img.height)
    //       // vm.bpWidth = Math.round(img.width * ratio)
    //       // vm.bpHeight = Math.round(img.height * ratio)
    //       vm.blueprint = vm.blueprint
    //     }
    //   }
    //   fileReader.readAsDataURL(imageBlob)
    // },
    onAreaChangeDelegate(index) {
      this.currentAreaKey = index
      this.activeIndex = index
      // this.activeIndex = index
      let currentArea = this.certificationProcess.areas[this.currentAreaKey]
      if (!currentArea.vertices || currentArea.vertices.length === 0) {
        this.$set(currentArea, 'vertices', [])
        let margem = 11
        // top left
        let v0 = {
          id: 0,
          x: currentArea.x,
          y: currentArea.y,
          photos: [
            {
              name: 'Chão',
              description: 'Fique em frente ao vértice e aponte para o chão',
              image: ''
            },
            {
              name: 'Teto',
              description: 'Fique em frente ao vértice e aponte para o teto',
              image: ''
            },
            {
              name: 'Vértice Oposto',
              description: 'Aponte para o vertice oposto',
              image: ''
            }
          ],
          type: 'vertice',
          name: 'Vértice Superior Esquerdo'
        }
        // top right
        let v1 = {
          id: 1,
          x: parseInt(currentArea.w, 10) + currentArea.x - margem,
          y: currentArea.y,
          photos: [
            {
              name: 'Chão',
              description: 'Fique em frente ao vértice e aponte para o chão',
              image: ''
            },
            {
              name: 'Teto',
              description: 'Fique em frente ao vértice e aponte para o teto',
              image: ''
            },
            {
              name: 'Vértice Oposto',
              description: 'Aponte para o vertice oposto',
              image: ''
            }
          ],
          type: 'vertice',
          name: 'Vértice Superior Direito'
        }
        // bottom right
        let v2 = {
          id: 2,
          x: parseInt(currentArea.w, 10) + currentArea.x - margem,
          y: parseInt(currentArea.h, 10) + currentArea.y - margem,
          photos: [
            {
              name: 'Chão',
              description: 'Fique em frente ao vértice e aponte para o chão',
              image: ''
            },
            {
              name: 'Teto',
              description: 'Fique em frente ao vértice e aponte para o teto',
              image: ''
            },
            {
              name: 'Vértice Oposto',
              description: 'Aponte para o vertice oposto',
              image: ''
            }
          ],
          type: 'vertice',
          name: 'Vértice Inferior Direito'
        }
        // bottom left
        let v3 = {
          id: 3,
          x: currentArea.x,
          y: parseInt(currentArea.h, 10) + currentArea.y - margem,
          photos: [
            {
              name: 'Chão',
              description: 'Fique em frente ao vértice e aponte para o chão',
              image: ''
            },
            {
              name: 'Teto',
              description: 'Fique em frente ao vértice e aponte para o teto',
              image: ''
            },
            {
              name: 'Vértice Oposto',
              description: 'Aponte para o vertice oposto',
              image: ''
            }
          ],
          type: 'vertice',
          name: 'Vértice Inferior Esquerdo'
        }

        currentArea.vertices.push(v0)
        currentArea.vertices.push(v1)
        currentArea.vertices.push(v2)
        currentArea.vertices.push(v3)

        this.SET_AREA({ area: currentArea, key: this.currentAreaKey })
      }
    },
    addStructure() {
      let vm = this
      vm.$refs.add_structure_dialog.openDialog(vm.currentAreaKey, null, null)
    },
    setInteractive() {
      console.log('set interactive')
      let vm = this
      vm.$interact('.draggable-structure').unset()
      vm.$interact('.draggable-structure')
        .draggable({
          inertia: false,
          max: Infinity,
          restrict: {
            restriction: 'parent',
            elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
          },
          autoScroll: false
        })
        .on('dragmove', (event) => {
          let target = event.target
          // keep the dragged position in the data-x/data-y attributes
          let x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx
          let y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy

          // translate the element
          target.style.webkitTransform = target.style.transform =
            'translate(' + x + 'px, ' + y + 'px)'

          // update the posiion attributes
          target.setAttribute('data-x', x)
          target.setAttribute('data-y', y)
        })
        .on('dragend', (event) => {
          let target = event.target
          let key = target.getAttribute('data-key')
          let x = parseFloat(target.getAttribute('data-x')) || 0
          let y = parseFloat(target.getAttribute('data-y')) || 0
          let item = this.certificationProcess.areas[this.currentAreaKey]
            .structures[key]
          item.x = x
          item.y = y
          this.certificationProcess.areas[this.currentAreaKey].structures[key] = item
          this.SET_PROCESS(this.certificationProcess)
        })
        .on('doubletap', (event) => {
          let target = event.target
          let key = target.getAttribute('data-key')
          let currentItem = this.certificationProcess.areas[this.currentAreaKey]
            .structures[key]
          this.$refs.add_structure_dialog.openDialog(
            this.currentAreaKey,
            currentItem,
            key
          )
          event.preventDefault()
        })
    },
    dragMoveListener(event) {
      console.log('drag move listener')
      let target = event.target
      // keep the dragged position in the data-x/data-y attributes
      let x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx
      let y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy

      // translate the element
      target.style.webkitTransform = target.style.transform =
        'translate(' + x + 'px, ' + y + 'px)'

      // update the posiion attributes
      target.setAttribute('data-x', x)
      target.setAttribute('data-y', y)
    },
    onEditStructure(key) {
      let currentItem = this.certificationProcess.areas[this.currentAreaKey]
        .structures[key]
      this.$refs.add_structure_dialog.openDialog(
        this.currentAreaKey,
        currentItem,
        key
      )
      // event.preventDefault()
    },
    nextArea(currentIndex) {
      this.activeIndex = currentIndex + 1
    },
    prevArea(currentIndex) {
      this.activeIndex = currentIndex - 1
    }
  }
}
</script>
<style scoped>
/*.blueprint {*/
/*  !* -ms-touch-action: none;*/
/*  touch-action: none; *!*/
/*  display: flex;*/
/*}*/

/*.draggable-structure {*/
/*  -webkit-transform: translate(0px, 0px);*/
/*  transform: translate(0px, 0px);*/
/*  !* This makes things *much* easier *!*/
/*  box-sizing: border-box;*/
/*  -ms-touch-action: none;*/
/*  touch-action: none;*/
/*  border-radius: 8px;*/
/*  position: absolute;*/
/*  background-color: rgba(255, 255, 255, 0.7);*/
/*}*/

/*.areas-navigation {*/
/*  position: absolute !important;*/
/*  top: 0 !important;*/
/*}*/

/*.areas-content {*/
/*  margin-top: 48%;*/
/*}*/

.no-equipments {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// StructureView.vue?6f730336